import { paths } from '@/paths';

export const baseMenuConfig = [
    {
        id: 'topSection',
        name: '',
        items: [
            {   id: 'home', 
                name: 'Home', 
                href: '/', 
                icon: 'house', 
                matcher: { type: 'equals', href: '/' } // used to determine if nav item is active (selected) which then highlights it in the sidebar. see lib/is-nav-item-active
            },
            {   id: 'alerts', 
                name: 'Alerts', 
                href: '/alerts', 
                icon: 'bell', 
                matcher: { type: 'startsWith', href: '/alerts' } 
            },
            {   id: 'historian', 
                name: 'Historian', 
                href: '/historian', 
                icon: 'hourglass', 
                matcher: { type: 'startsWith', href: '/historian' } 
            },
        ],
    },
]